const B_1 = [
    {
        title: '查看专家质疑',
        path: '/bidding/projectflow/pingbiao/ckzjzy/list'
    }
]
export default {
    path: 'ckzjzy',
    component: () => import(/*webpackChunkName: 'bidding-ping-ckzjzy'*/ '@layout/empty'),
    children: [
        {
            path:"list",
            component: () => import('@views/bidding/views/project-flow/ping/ckzjzy/list'),
            meta: {
                title: '专家评标问题',
                bread: B_1
            },
        },
        {
            path:"hfdetail",
            component: () => import('@views/bidding/views/project-flow/ping/ckzjzy/hfdetail'),
            meta: {
                title: '回复问题管理',
                bread: B_1
            },
        },
        {                                       
            path:"detail",
            component: () => import('@views/bidding/views/project-flow/ping/ckzjzy/detail'),
            meta: {
                title: '评标澄清问题管理',
                bread: B_1
            },
        },
    ]
} 